import React, { useState } from "react";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import ClickAwayListener from "@mui/material/ClickAwayListener";

export default function MuiPopper({ Icon, children ,style={}}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ padding: 0 ,...style}}>
      <IconButton onClick={handleClick}>{Icon}</IconButton>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        sx={{ zIndex: 1400 }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Paper
            sx={{ zIndex: 1400 }}
            style={{
              padding: "10px",
              borderRadius: "12px",
              marginTop: "8px",
              minWidth: "180px",
              boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
            }}
          >
            {typeof children === "function"
              ? children({ handleClose })
              : children}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}
